import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/documentation/subscription-funnel-texts')({
  component: () => <Navigate replace search to="/bo/documentation/subscription-funnel-texts" />,
})
